import { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const logoUrl = '/img/logo.png';

const menuItems = [
  { label: 'Dashboard', path: '/admin', icon: 'ri-dashboard-line' },
  { label: 'Categorias', path: '/admin/categorias', icon: 'ri-price-tag-3-line' },
  { label: 'Produtos', path: '/admin/produtos', icon: 'ri-shopping-bag-2-line' },
  { label: 'Coleções', path: '/admin/colecoes', icon: 'ri-stack-line' },
  { label: 'Textos do site', path: '/admin/textos', icon: 'ri-file-text-line' },
  { label: 'Banners', path: '/admin/banners', icon: 'ri-image-line' },
  { label: 'Informações da loja', path: '/admin/informacoes', icon: 'ri-store-2-line' },
  { label: 'Pedidos recebidos', path: '/admin/pedidos', icon: 'ri-inbox-line' },
  { label: 'Configurações', path: '/admin/configuracoes', icon: 'ri-settings-3-line' },
];

function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('admin_logged_in');
    navigate('/admin/login');
  };

  const sidebar = (
    <aside className="w-60 bg-white border-r border-background-200 flex flex-col h-full shrink-0">
      {/* Logo */}
      <div className="px-5 py-5 border-b border-background-100">
        <div className="flex items-center gap-3">
          <img src={logoUrl} alt="Maçã Verde" className="w-9 h-9 rounded-full object-cover" />
          <div>
            <p className="font-heading text-sm font-semibold text-foreground-900 leading-tight">Maçã Verde</p>
            <p className="text-[10px] text-foreground-500">Painel Admin</p>
          </div>
        </div>
      </div>

      {/* Menu */}
      <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-0.5">
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path || (item.path !== '/admin' && location.pathname.startsWith(item.path));
          return (
            <button
              key={item.path}
              type="button"
              onClick={() => {
                navigate(item.path);
                setSidebarOpen(false);
              }}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${isActive
                  ? 'bg-primary-50 text-primary-700'
                  : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-800'
                }`}
            >
              <i className={`${item.icon} text-base ${isActive ? 'text-primary-600' : 'text-foreground-400'}`} />
              {item.label}
            </button>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="px-3 py-4 border-t border-background-100">
        <button
          type="button"
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-500 hover:bg-red-50 hover:text-red-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-logout-box-r-line text-base" />
          Sair
        </button>
      </div>
    </aside>
  );

  return (
    <div className="flex h-screen bg-background-50 overflow-hidden">
      {/* Desktop Sidebar */}
      <div className="hidden lg:block">{sidebar}</div>

      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="absolute inset-0 bg-black/40" onClick={() => setSidebarOpen(false)} />
          <div className="relative z-10">{sidebar}</div>
        </div>
      )}

      {/* Main */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Top bar */}
        <header className="h-14 border-b border-background-200 bg-white flex items-center justify-between px-4 shrink-0">
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={() => setSidebarOpen(true)}
              className="lg:hidden w-8 h-8 flex items-center justify-center rounded-lg hover:bg-background-100 text-foreground-600"
            >
              <i className="ri-menu-line text-lg" />
            </button>
            <span className="text-sm font-medium text-foreground-700 hidden sm:block">Maçã Verde</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-foreground-500 hidden sm:block">Administrador</span>
            <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-user-line text-sm text-primary-600" />
            </div>
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border border-background-200 text-foreground-600 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-external-link-line" />
              Ver site
            </a>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;